import React from 'react'
import cn from 'classnames'

import { useMutiSelectDropDown } from '@hooks/useDropdown'
import { CheckboxInput } from '@components/CheckboxInput'
import { ChevronDownIcon } from '@components/icons/ChevronDownIcon'
import { CrossIcon } from '@components/icons/CrossIcon'
import { MultiSelectFieldPropsType } from './interface'

export function MultiSelectField({
  className,
  optionClassName,
  options,
  label,
  value,
  placeholder,
  handleRemove,
  isInputLabel,
  ...props
}: MultiSelectFieldPropsType) {
  const { dropdownRef, isShowDropdown, toggleDropdown } =
    useMutiSelectDropDown()

  return (
    <div className='text-secondary dark:text-dark-10'>
      {label && !isInputLabel && (
        <div className='text-[12px] font-light mb-[4px] text-secondary-1'>
          {label}
        </div>
      )}

      <div
        className={cn(
          'flex space-x-[10px] min-h-[40px] px-[10px] items-center py-[3px]  border border-gray-3 dark:border-purple dark:bg-dark-8 rounded-[8px] cursor-pointer',
          { 'border-primary': isShowDropdown }
        )}
        onClick={toggleDropdown}
      >
        <div className='flex-1 flex flex-wrap space-x-[6px]'>
          {label && isInputLabel && (
            <div className='text-[14px] text-secondary-1'>{label} : </div>
          )}
          {(value as string[]).length ? (
            options.map(option =>
              (value as string[])?.find(row => row === option.value) ? (
                <div
                  key={option.value}
                  className='flex items-center space-x-[5px] my-[3px] text-[14px] bg-secondary dark:bg-purple font-light rounded-[8px] text-white dark:text-white-2 px-[10px]'
                >
                  <div className='break-word'>{option.label}</div>
                  <button
                    type='button'
                    onClick={event => {
                      event.stopPropagation()
                      handleRemove(option.value)
                    }}
                  >
                    <CrossIcon className='w-[14px] h-[14px]' />
                  </button>
                </div>
              ) : null
            )
          ) : (
            <div className='text-[14px] font-light text-secondary-1'>
              {placeholder}
            </div>
          )}
        </div>
        <ChevronDownIcon className='w-[16px] h-[16px] text-primary' />
      </div>
      <div className='relative'>
        <div
          ref={dropdownRef}
          className={cn(
            'absolute shadow-dropdown border border-gray-4 dark:border-purple w-full top-[5px] z-10 bg-white dark:bg-dark-12 rounded-[8px] max-h-[315px] overflow-y-auto py-[10px]',
            {
              hidden: !isShowDropdown,
            }
          )}
        >
          {options.map(option => (
            <div
              key={option.value}
              className='flex items-center text-[14px] px-[10px] py-[3px] font-light hover:bg-primary-1 dark:hover:bg-dark hover:text-primary dark:hover:text-dark-10'
            >
              <CheckboxInput
                {...props}
                value={option.value}
                checked={(value as string[])?.includes(option.value)}
              >
                {option.label}
              </CheckboxInput>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
